const React = require("react");

require("./MajorError.less");

const ErrorType = require("~/types/Error.js").PropType;

const HttpResponse = require("../HttpResponse/HttpResponse.jsx");

const MajorError = React.createClass({
    propTypes: {
        Error: ErrorType.isRequired
    },
    render() {
        const hasResponse =
            this.props.Error.hasOwnProperty("response")
            && this.props.Error.response !== null;

        return (<div className="cs-MajorError">
            <h3 className="cs-MajorError__message">
                Error: {this.props.Error.message}
            </h3>
            {hasResponse && (<HttpResponse Response={this.props.Error.response} />)}
        </div>);
    }
});

module.exports = MajorError;


// WEBPACK FOOTER //
// ./src/components/MajorError/MajorError.jsx